"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var GroupedList_styles_1 = require("./GroupedList.styles");
var GroupedList_base_1 = require("./GroupedList.base");
exports.GroupedList = Utilities_1.styled(GroupedList_base_1.GroupedListBase, GroupedList_styles_1.getStyles, undefined, {
    scope: 'GroupedList'
});
//# sourceMappingURL=GroupedList.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/GroupedList/GroupedList.js
// module id = 877
// module chunks = 0